import React, { Suspense } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Skeleton } from '@mui/material';
const ImportRosterView = React.lazy(() => import('./import/ImportRosterView'));
import { Client } from '../../../../models/core';

interface Props {
    open:boolean;
    client:Client;
    onClose?:() => void;
}

const RosterDialog: React.FC <Props> = ({open, client, onClose}) => {
    return <Dialog open={open} PaperProps={{ sx: { height:'90%', maxHeight:'90%', width: '70%', maxWidth: '70%' } }} >
        <DialogTitle>Rosters</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'row' }}>
            <Suspense fallback={<Skeleton variant='rounded' width={'100%'} height={'5em'}/>}>
                <ImportRosterView client={client}/>
            </Suspense>
        </DialogContent>
        <Button variant='outlined' onClick={onClose}>Close </Button>
    </Dialog>
};

export default RosterDialog;